import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initSmoothScroll({ reduced = false } = {}) {
  if (reduced) return { start() {}, stop() {}, destroy() {} };

  const lenis = new Lenis({
    duration: 1.25,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
  });

  let ready = false;
  const raf = (time) => lenis.raf(time * 1000);
  gsap.ticker.add(raf);
  gsap.ticker.lagSmoothing(0);
  lenis.on('scroll', ScrollTrigger.update);
  lenis.stop();

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      lenis.scrollTo(target, { offset: 0, duration: 1.6 });
    });
  });

  const menuObserver = new MutationObserver(() => {
    if (document.body.classList.contains('menu-open')) lenis.stop();
    else if (ready) lenis.start();
  });
  menuObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  const api = {
    start() {
      ready = true;
      if (!document.body.classList.contains('menu-open')) lenis.start();
      ScrollTrigger.refresh();
    },
    stop() { lenis.stop(); },
    destroy() {
      menuObserver.disconnect();
      gsap.ticker.remove(raf);
      lenis.destroy();
    },
  };

  window.__lenis = lenis;
  return api;
}
